
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/printemps-orientation",
      function () {
        return require("private-next-pages/printemps-orientation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/printemps-orientation"])
      });
    }
  